<template>
    <div class="main">
        <MyHeader index="1"></MyHeader>
        <div class="title">
            <div class="container">
                <h2>关于我们</h2>
                <h3>About us</h3>
            </div>
        </div>
        <div class="aboutUsInfo">
            <div class="container">
                <div class="content">
                    <div class="leftMenu">
                        <ul>
                            <li>
                                <router-link to="/aboutUs">
                                    <i>{{$t('ccapp.tit')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/frame">
                                    <i>{{$t('ccapp.tit1')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                            <li class="on">
                                <router-link to="/job">
                                    <i>{{$t('ccapp.tit5')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                        <div class="jobInfo" v-if="id === 1 && this.$i18n.locale == 'zh_CN'">
                            <h3>项目经理</h3>
                            <h5>2020-08-20</h5>
                            <h6>工作地点：北京</h6>
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. 开展国内外清洁空气政策、方法和技术等相关中英文研究报告和评估报告的编制工作，组织完成中国清洁空气年度报告；</p>
                                </li>
                                <li>
                                    <p>2. 为政府部门空气质量改善行动提供技术支持和建议； </p>
                                </li>
                                <li>
                                    <p>3. 与国内和国际研究机构共同开展清洁空气技术和政策相关研究；</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. 环境类或相关专业硕士及以上学历（优秀本科生亦可）， 有NGO相关工作经历者优先；</p>
                                </li>
                                <li>
                                    <p>2. 具备大气污染防治领域相关研究经验；</p>
                                </li>
                                <li>
                                    <p>3. 良好的中英文写作能力，较好的英语口语表达能力；</p>
                                </li>
                                <li>
                                    <p>4. 责任心强，工作认真细心，有能力同时完成多个项目的工作；</p>
                                </li>
                                <li>
                                    <p>5. 具有良好的沟通能力和学习能力，以及较强的团队协作能力。</p>
                                </li>
                            </ul>
                            <h4>薪资待遇</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>根据申请人情况提供具有竞争力的薪酬，具体面议；提供五险一金、带薪休假、进修培训等福利。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；标题格式为：姓名+职位+最快到岗时间。</p>
                                </li>
                            </ul>
                        </div>
                        <div class="jobInfo" v-if="id === 1 && this.$i18n.locale == 'en_US'">
                            <h3>Project Manager</h3>
                            <h5>2020-08-20</h5>
                            <h6>Location：Beijing</h6>
                            <h4>Key Responsibilities</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. Writing both English and Chinese research reports and assessment reports regarding clean air policies, methods and technologies；</p>
                                </li>
                                <li>
                                    <p>2. Providing technical support and suggestions for government’s actions for air quality improvement； </p>
                                </li>
                                <li>
                                    <p>3. Carrying out research on technologies and policies about cleaning air in cooperation with domestic and oversea institutes；</p>
                                </li>
                            </ul>
                            <h4>Qualifications</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. Master’s degree or above, in the field of environmental science or relevant disciplines (excellent Bachelors’ degree holders can also be considered). Experience in NGO is preferred；</p>
                                </li>
                                <li>
                                    <p>2. Experience in studying prevention of atmospheric pollution or relevant field；</p>
                                </li>
                                <li>
                                    <p>3. Fluency in both oral and written English and Chinese；</p>
                                </li>
                                <li>
                                    <p>4. Responsibility and carefulness in work, ability in dealing with multiple tasks simultaneously；</p>
                                </li>
                                <li>
                                    <p>5. Good communication and learning skills, team player。</p>
                                </li>
                            </ul>
                            <h4>Salary and Benefits</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>A competitive salary is offered based on the qualifications of the applicant. Five insurances and housing fund, paid vacation, training and other benefits are also offered.</p>
                                </li>
                            </ul>
                            <h4>How to Apply</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>Send CV to makeinsight@makeins.cn</p>
									<p>Please write the email subject line as: Name/Position/the earliest time of arrival.</p>
                                </li>
                            </ul>
                        </div>
                        
                        <div class="jobInfo" v-if="id === 2 && this.$i18n.locale == 'zh_CN'">
                            <h3>媒体经理</h3>
                            <h5>2019-05-06</h5>
                            <h6>工作地点：北京</h6>
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  策划与实施清洁空气伙伴项目相关的会议和交流活动；</p>
                                </li>
                                <li>
                                    <p>2  通过微信或其他平面媒体宣传和推广大气污染治理经验；</p>
                                </li>
                                <li>
                                    <p>3  拓展及维护国内和国际研究机构、相关管理职能部门等 业内人士的公共关系。</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 新闻传播类、环境类或相关专业硕士及以上学历（优秀 本科生亦可）；</p>
                                </li>
                                <li>
                                    <p>2 较好的英语口语表达能力，良好的中英文写作能力；</p>
                                </li>
                                <li>
                                    <p>3 具有相关工作经验，具备大气污染防治知识背景，对环 境问题，特别是空气污染的知识有浓厚兴趣；</p>
                                </li>
                                <li>
                                    <p>4 责任心强，工作认真，具有良好的沟通能力和学习能力，以及较强的团队协作能力。</p>
                                </li>

                            </ul>
                            <h4>薪资待遇</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>根据申请人情况提供具有竞争力的薪酬，具体面议；提供五险一金、带薪休假、进修培训等福利。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；标题格式为：姓名+职位+最快到岗时间。</p>
                                </li>
                            </ul>
                        </div>
                        <div class="jobInfo" v-if="id === 2 && this.$i18n.locale == 'en_US'">
                            <h3>Media Manager</h3>
                            <h5>2020-08-20</h5>
                            <h6>Location：Beijing</h6>
                            <h4>Key Responsibilities</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  Writing both English and Chinese research reports and assessment reports regarding clean air policies, methods and technologies；</p>
                                </li>
                                <li>
                                    <p>2  Providing technical support and suggestions for government’s actions for air quality improvement；</p>
                                </li>
                                <li>
                                    <p>3  Carrying out research on technologies and policies about cleaning air in cooperation with domestic and oversea institutes；</p>
                                </li>
                            </ul>
                            <h4>Qualifications</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 Master’s degree or above, in the field of environmental science or relevant disciplines (excellent Bachelors’ degree holders can also be considered). Experience in NGO is preferred；</p>
                                </li>
                                <li>
                                    <p>2 Experience in studying prevention of atmospheric pollution or relevant field；</p>
                                </li>
                                <li>
                                    <p>3 Fluency in both oral and written English and Chinese；</p>
                                </li>
                                <li>
                                    <p>4 Responsibility and carefulness in work, ability in dealing with multiple tasks simultaneously；</p>
                                </li>
                                <li>
                                    <p>5 Good communication and learning skills, team player；</p>
                                </li>

                            </ul>
                            <h4>Salary and Benefits</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>A competitive salary is offered based on the qualifications of the applicant. Five insurances and housing fund, paid vacation, training and other benefits are also offered.</p>
                                </li>
                            </ul>
                            <h4>How to Apply</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>Send CV to makeinsight@makeins.cn</p>
									<p>Please write the email subject line as: Name/Position/the earliest time of arrival.</p>
                                </li>
                            </ul>
                        </div>
                        
                        
                        <div class="jobInfo" v-if="id === 4 && this.$i18n.locale == 'zh_CN'">
                            <h3>传播官员</h3>
                            <p>CCAPP 秘书处现招聘1名传播官员，参与信息传播、管理与交流等工作。</p>
                            <h5>2020-12-22</h5>
                            <h6>工作地点：北京</h6>
                           
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  协助策划与实施清洁空气伙伴项目相关的会议和交流活动；</p>
                                </li>
                                <li>
                                    <p>2  协助通过微信或其他平面媒体宣传和推广大气污染治理经验及协同应对气候变化相关内容；</p>
                                </li>
                                <li>
                                    <p>3  协助拓展及维护国内和国际研究机构、相关管理职能部门等业内人士的公共关系。</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 新闻传播类、环境类或相关专业硕士及以上学历（优秀本科生亦可），具有相关工作经验，具有NGO工作经验者优先；</p>
                                </li>
                                <li>
                                    <p>2 较好的中英文沟通能力，良好的中英文写作能力；</p>
                                </li>
                                <li>
                                    <p>3 较强的宣传推广、组织策划与协调能力；</p>
                                </li>
                                <li>
                                    <p>4 具备大气污染防治、气候变化应对相关知识背景，对环境问题，特别是空气污染的知识有浓厚兴趣；</p>
                                </li>
                                 <li>
                                    <p>5 责任心强，工作认真，具有良好的学习能力和创新精神，以及较强的团队协作能力。</p>
                                </li>

                            </ul>
                            <h4>薪资待遇</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>根据申请人情况提供具有竞争力的薪酬，具体面议；提供五险一金、带薪休假、进修培训等福利。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；标题格式为：姓名+职位+最快到岗时间。</p>
                                </li>
                            </ul>
                        </div>
                        <div class="jobInfo" v-if="id === 4 && this.$i18n.locale == 'en_US'">
                            <h3>Communication Assistant</h3>
                            <p>The CCAPP Secretariat is now hiring one Communication Assistant to participate in information dissemination, as well as management and communication activities. </p>
                            <h5>2020-12-22</h5>
                            <h6>Location：Beijing</h6>
                            <h4>Key Responsibilities</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  Planning and implementing meetings and communication activities related to clean air partnership programs.</p>
                                </li>
                                <li>
                                    <p>2  Promoting and sharing experience regarding air pollution prevention and control via WeChat or other social media.</p>
                                </li>
                                <li>
                                    <p>3  Expanding and maintaining the relationships with domestic and international research institutes, industry professionals and other authorities.</p>
                                </li>
                            </ul>
                            <h4>Qualifications</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 Master’s degree or above, in journalism, environmental science or relevant disciplines (excellent Bachelors’ degree holders maybe be considered), NGO related working experiences are assets </p>
                                </li>
                                <li>
                                    <p>2 Research experience in air pollution prevention and control, climate change mitigation, or related field;</p>
                                </li>
                                <li>
                                    <p>3 Fluent in spoken and written English and Chinese;</p>
                                </li>
                                <li>
                                    <p>4 Familiar with campaign and content promoting; strong ability of planning and coordination;</p>
                                </li>
                                <li>
                                    <p>5 Strong sense of responsibility, detail-oriented, and able to conduct multiple tasks simultaneously;</p>
                                </li>
                                <li>
                                    <p>6 Good communication and learning skills, and a good team player.</p>
                                </li>

                            </ul>
                            <h4>Salary and Benefits</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>A competitive salary is offered based on the qualifications of the applicant. Five insurances and housing fund, paid vacation, training and other benefits are also offered.</p>
                                </li>
                            </ul>
                            <h4>How to Apply</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>Send CV to makeinsight@makeins.cn</p>
									<p>Please write the email subject line as: Name/Position/the earliest time of arrival.</p>
                                </li>
                            </ul>
                        </div>
                        
                    
                    	<div class="jobInfo" v-if="id === 5 && this.$i18n.locale == 'zh_CN'">
                            <h3>项目官员</h3>
                            <p>CCAPP 秘书处现招聘1名项目官员，参与相关研究、管理与交流等工作。</p>
                             <h5>2020-12-22</h5>
                            <h6>工作地点：北京</h6>
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  协助开展国内外清洁空气政策、方法和技术等相关中英文研究报告和评估报告的编制工作，协助完成中国清洁空气年度报告；</p>
                                </li>
                                <li>
                                    <p>2  协助为政府部门空气质量改善行动提供技术支持和建议；</p>
                                </li>
                                <li>
                                    <p>3  协助与国内和国际研究机构共同开展清洁空气技术和政策相关研究。</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 环境类或相关专业硕士及以上学历（优秀本科生亦可），有NGO 相关工作经历者优先；</p>
                                </li>
                                <li>
                                    <p>2 具备大气污染防治、气候变化应对领域相关研究经验；</p>
                                </li>
                                <li>
                                    <p>3 良好的中英文写作能力，较好的英语口语表达能力；</p>
                                </li>
                                <li>
                                    <p>4 责任心强，工作认真细心，有能力同时完成多个项目的工作；</p>
                                </li>
                                 <li>
                                    <p>5 具有良好的沟通能力和学习能力，以及较强的团队协作能力。</p>
                                </li>

                            </ul>
                            <h4>薪资待遇</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>根据申请人情况提供具有竞争力的薪酬，具体面议；提供五险一金、带薪休假、进修培训等福利。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；标题格式为：姓名+职位+最快到岗时间。</p>
                                </li>
                            </ul>
                        </div>
                        <div class="jobInfo" v-if="id === 5 && this.$i18n.locale == 'en_US'">
                            <h3>Project Assistant</h3>
                            <p>The CCAPP Secretariat is now hiring one Project Assistant to participate in research projects, as well as management and communication activities. </p>
                             <h5>2020-12-22</h5>
                            <h6>Location：Beijing</h6>
                            <h4>Key Responsibilities</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1  Assisting in writing both English and Chinese research and assessment reports regarding clean air policies, methods and technologies;</p>
                                </li>
                                <li>
                                    <p>2  Providing technical support and suggestions for government air quality improvement initiatives;</p>
                                </li>
                                <li>
                                    <p>3  Conducting research on clean air technologies and policies by collaborating with national and international research institutes .</p>
                                </li>
                            </ul>
                            <h4>Qualifications</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1 Master’s degree or above, in environmental science or relevant disciplines (excellent Bachelors’ degree holders may also be considered). Working experience in NGO is preferred;</p>
                                </li>
                                <li>
                                    <p>2 Research experience in air pollution prevention and control, climate change mitigation, or related field;</p>
                                </li>
                                <li>
                                    <p>3 Fluent in spoken and written English and Chinese;</p>
                                </li>
                                
                                <li>
                                    <p>4 Strong sense of responsibility, paying attention to detail, and able to conduct multiple tasks simultaneously;</p>
                                </li>
                                <li>
                                    <p>5 Good communication and learning skills, and a good team player.</p>
                                </li>

                            </ul>
                            <h4>Salary and Benefits</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>A competitive salary is offered based on the qualifications of the applicant. Five insurances and housing fund, paid vacation, training and other benefits are also offered.</p>
                                </li>
                            </ul>
                            <h4>How to Apply</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>Send CV to makeinsight@makeins.cn</p>
									<p>Please write the email subject line as: Name/Position/the earliest time of arrival.</p>
                                </li>
                            </ul>
                        </div>
                        
                        
                        <div class="jobInfo" v-if="id === 3">
                            <h3>实习生</h3>
                            <h5>2019-05-06</h5>
                            <h6>工作地点：北京</h6>
                            <h4>岗位职责</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. 跟踪清洁空气领域相关数据：整理清洁空气领域政策、协助收集数据资料、数据整理分析；</p>
                                </li>
                                <li>
                                    <p>2. 协助举办线下会议与活动：活动资料准备、活动配套传播工作。 </p>
                                </li>
                                <li>
                                    <p>3. 信息传播：网站、微信公众号筹建维护。</p>
                                </li>
                            </ul>
                            <h4>任职资格</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>1. 全日制在读研究生或本科生。</p>
                                </li>
                                <li>
                                    <p>2. 能连续工作6个月左右。每周一到周五之间至少可以有3天来办公室工作</p>
                                </li>
                                <li>
                                    <p>3. 对清洁空气及低碳规划领域的工作有浓厚兴趣；优秀的逻辑思维和分析能力；优秀的中英文表达沟通能力；</p>
                                </li>
                                <li>
                                    <p>4. 强烈的工作责任感；强烈的求知欲和出色的学习能力。</p>
                                </li>
                                <li>
                                    <p>5. 具备大气污染防治领域相关经验者优先</p>
                                </li>
                                <li>
                                    <p>6. 具有新闻稿撰写、微信公众号运营经验者优先。</p>
                                </li>
                            </ul>
                            <h4>申请方式</h4>
                            <ul class="jobInfoText">
                                <li>
                                    <p>有意者请将个人简历发至：makeinsight@makeins.cn；</p>
                                </li>
                                <li>
                                    <p>邮件标题格式为：姓名-性别-学校-专业-预计毕业时间-连续实习*个月-每周能工作*个工作日（周一至周五之间）</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import MyHeader from './common/MyHeader';
    import MyFooter from './common/MyFooter';
    export default {
        name: "WorkExperiencePage",
        components: { MyHeader,MyFooter },
        data(){
            return{
                id:Number(this.$route.params.id)
            }
        },
        mounted(){
        }
    }
</script>

<style lang="scss" scoped>
    .main{
        .title{
            height:380px;
            background: url("./image/aboutUsImg.jpg") no-repeat center center;
            background-size: cover;
            .container{
                h2{
                    padding-top: 180px;
                    text-align: center;
                    color: #304656;
                    height:42px;
                    font-size:32px;
                    font-weight:bold;
                    line-height:42px;
                }
                h3{
                    text-align: center;
                    height:29px;
                    font-size:22px;
                    line-height:29px;
                    color: #304656;
                }
            }
        }
        .aboutUsInfo{
            .container{
                border-top: 1px solid #E6E6E6;
                .content{
                    margin-top: 66px;
                    overflow: hidden;
                    margin-bottom: 48px;
                    .leftMenu{
                        width: 246px;
                        float: left;
                        ul{
                            li{
                                padding: 0 16px;
                                border-radius: 18px;
                                height: 36px;
                                overflow: hidden;
                                line-height: 36px;
                                margin-bottom: 10px;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                a{
                                    display: block;
                                    height: 100%;
                                }
                                i{
                                    display: inline-block;
                                    float: left;
                                    color: #252525;
                                    font-size: 16px;
                                }
                                b{
                                    display: inline-block;
                                    float: right;
                                    width: 30px;
                                    height: 100%;
                                    background: url("./image/yy2.png") no-repeat center center;
                                    background-size: 100%;
                                    line-height: 36px;
                                }

                            }
                            .on{
                                background: #13AE67;
                                i{
                                    color: #FFFFFF;
                                }
                                b{
                                    background: url("./image/yy.png") no-repeat center center;
                                    background-size: 86%;
                                }
                            }
                        }
                    }
                    .rightContent{
                        float: right;
                        margin-left: 88px;
                        width: 866px;
                        .jobInfo{
                            h3{
                                height:26px;
                                font-size:20px;
                                font-weight:bold;
                                color:rgba(37,37,37,1);
                                line-height:26px;
                            }
                            h5{
                                margin-top: 12px;
                                height:12px;
                                font-size:12px;
                                color:rgba(102,102,102,1);
                                line-height:16px;
                            }
                            h6{
                                margin-top: 12px;
                                height:16px;
                                font-size:14px;
                                color:rgba(102,102,102,1);
                                line-height:16px;
                            }
                            h4{
                                height:21px;
                                font-size:16px;
                                font-weight:bold;
                                color:rgba(37,37,37,1);
                                line-height:21px;
                                margin-top: 33px;
                            }
                            .jobInfoText{
                                margin-top: 16px;
                                li{
                                    line-height:34px;
                                    font-size:14px;
                                    p{
                                        color: #252525;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
